// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Icon-module__main--w_VWV {
    --size: 24px;
    display: inline-block;
    width: var(--size);
    height: var(--size);
}

.Icon-module__main--w_VWV svg {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Icon/Icon.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".main {\n    --size: 24px;\n    display: inline-block;\n    width: var(--size);\n    height: var(--size);\n}\n\n.main svg {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Icon-module__main--w_VWV`
};
export default ___CSS_LOADER_EXPORT___;
